export class LegalGuardian {
    constructor(legalGuardianState) {
        this.legalGuardianState = legalGuardianState;
    }
    get id() { return this.legalGuardianState.id; }
    get ndiligencia() { return this.legalGuardianState.ndiligencia; }
    get representante() { return this.legalGuardianState.representante; }
    get date_time() { return this.legalGuardianState.date_time; }
    get colegiado() { return this.legalGuardianState.colegiado; }
    get usuario() { return this.legalGuardianState.usuario; }
    set ndiligencia(ndiligencia) { this.legalGuardianState.ndiligencia = ndiligencia; }
    set representante(representante) { this.legalGuardianState.representante = representante; }
    set date_time(date_time) { this.legalGuardianState.date_time = date_time; }
    set colegiado(colegiado) { this.legalGuardianState.colegiado = colegiado; }
    set usuario(usuario) { this.legalGuardianState.usuario = usuario; }
    getState() { return this.legalGuardianState; }
}
